<template>
  <div>
    <div style="display: flex;justify-content: space-between;align-items: center">
      <div style="width: 600px">
        <el-table
          :data="info_data"
          border
        >
          <el-table-column prop="name" align="center" label="用户动作" />
          <el-table-column prop="num" align="center" label="允许下发条数限制" />
          <el-table-column prop="time" align="center" label="下发时限" />
        </el-table>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="openDialog(null,1)">添加</el-button>
      </div>
    </div>
    <div style="margin: 20px 0;font-weight: bold">1、可发送客服消息条数不累加，上述用户动作会触发可下发条数及可下发时限的更新，可下发消息条数更新为当前可下发条数限制的最大值，有效下发时间限制也更新为最长有效时间。</div>
    <div style="margin: 20px 0;font-weight: bold">2、停用功能：对于停用前进入的用户延时消息会停止发送</div>
    <div style="margin-bottom: 20px;">内推链接 <el-tag>{{ page_path }}</el-tag><i
      v-clipboard:copy="`${page_path}`"
      v-clipboard:success="onCopys"
      v-clipboard:error="onErrors"
      class="el-icon-document-copy"
      style="color: #165DFF; border: 0; font-size: 14px; cursor: pointer; margin-left:6px;"
    /></div>
    <div style="margin-bottom: 20px;">外推链接 <el-tag>{{ url_link }}</el-tag><i
      v-clipboard:copy="`${url_link}`"
      v-clipboard:success="onCopys"
      v-clipboard:error="onErrors"
      class="el-icon-document-copy"
      style="color: #165DFF; border: 0; font-size: 14px; cursor: pointer; margin-left:6px;"
    /></div>
    <el-button icon="el-icon-refresh-right" style="margin-bottom: 10px" type="primary" @click="suanewrq">一键修改获客链接（图文链接类型）</el-button>
    <el-table
      :data="tableData.list"
      border
    >
      <el-table-column prop="id" align="center" label="id" />
      <el-table-column prop="behavior_text" align="center" label="触发行为" />
      <el-table-column prop="msg_type" align="center" label="信息类型">
        <template slot-scope="scope">{{ typeMap[scope.row.msg_type] || '未知类型' }}</template>
      </el-table-column>
      <el-table-column prop="msg_type" align="center" label="延时时间">
        <template slot-scope="scope">{{ scope.row.delay_seconds.hours }}时{{ scope.row.delay_seconds.minutes }}分{{ scope.row.delay_seconds.seconds }}秒</template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template #default="{ row }">
          <el-switch
            v-model="row.status"
            :active-value="1"
            :inactive-value="2"
            active-color="#13ce66"
            inactive-color="#dcdfe6"
            :disabled="row._switchDisabled"
            @change="val => handleToggle(val, row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="openDialog(scope.row,2)">修改</el-button>
          <el-button type="danger" size="mini" @click="delDelay(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      ref="paginationbox"
      :total="tableData.total"
      @size-change="fetchPageSizer"
      @current-change="fetchCurrentPager"
    />
    <el-dialog
      :title="status===1? '创建延时消息':'修改延时消息'"
      :visible.sync="msgInfoVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      append-to-body
      wdith="990px"
    >
      <delayed-msg ref="delayed_msg" @commit="commit" @close="msgInfoVisible = false" />
    </el-dialog>
    <el-dialog
      :title="'修改获客链接（图文链接类型）'"
      :visible.sync="editInfoVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      append-to-body
      width="30%"
    >
      <editlink ref="editlinkview" @iodawqq="iodawqq" />
    </el-dialog>
  </div>
</template>

<script>
import {
// employeeFriendChange,
} from '@/api/officialaccount'
import { delayedMsgList, createDelayedMsg, updDelayedMsg, delDelayedMsg, changeSwitchMsg } from '@/api/bserw'
import DelayedMsg from '@/views/redenvelope/components/delayedMsg.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import editlink from './editlink.vue'
export default {
  components: { PaginationRight, DelayedMsg, editlink },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        iqiyi_promotion_link_no: null
      },
      tableData: {
        total: 0,
        list: []
      },
      msgInfoVisible: false,
      typeMap: {
        text: '文本',
        img: '图片',
        news: '图文链接',
        miniprogrampage: '小程序'
      },
      status: 1,
      info_data: [
        {
          name: '用户发送消息',
          num: '5条',
          time: '48小时'
        },
        {
          name: '用户进入客服消息',
          num: '2条',
          time: '1分钟'
        }
      ],
      page_path: '',
      url_link: '',
      editInfoVisible: false
    }
  },
  methods: {
    send(val) {
      console.log(val)
      this.query.iqiyi_promotion_link_no = val.iqiyi_promotion_link_no
      this.page_path = val.page_path
      this.url_link = val.url_link
      this.getList()
    },
    getList() {
      delayedMsgList(this.query).then(res => {
        console.log(res)
        if (res.code === 200) {
          this.tableData = res.data
        }
      })
    },
    openDialog(val, status) {
      this.msgInfoVisible = true
      this.status = status
      setTimeout(() => {
        // // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.delayed_msg.send(val, true)
      }, 100)
    },
    handleToggle(newVal, row) {
      console.log(newVal, row)
      // 立即更新UI
      this.$set(row, '_switchDisabled', true)
      // 模拟接口或刷新机制（你可能1秒后重新拉表格数据）
      setTimeout(() => {
        row._switchDisabled = false // 恢复点击
        // 如果你有刷新列表，这一步也可以省略
      }, 1000)
      changeSwitchMsg({ id: row.id, status: newVal }).then(res => {
        console.log(res)
        if (res.code === 200) {
          this.$message.success('修改成功')
        }
      })
    },
    delDelay(val) {
      console.log(val)
      this.$confirm('确定要删除此消息吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        delDelayedMsg({ id: val.id }).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getList()
          }
        })
      })
    },
    commit(val) {
      console.log(val)
      const data = { ...val, iqiyi_promotion_link_no: this.query.iqiyi_promotion_link_no }
      if (this.status === 1) {
        createDelayedMsg(data).then(res => {
          if (res.code === 200) {
            this.$message.success('添加成功')
            this.msgInfoVisible = false
            this.getList()
          }
        })
      } else {
        updDelayedMsg(data).then(res => {
          if (res.code === 200) {
            this.$message.success('修改成功')
            this.msgInfoVisible = false
            this.getList()
          }
        })
      }
    },
    fetchPageSizer(e) {
      this.query.page_size = e
      this.getList()
    },
    fetchCurrentPager(e) {
      this.query.page = e
      this.getList()
    },
    onCopys() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    onErrors() {
      this.$message.error('复制失败')
    },
    suanewrq() {
      this.editInfoVisible = true
      setTimeout(() => {
        // // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.editlinkview.send(this.query.iqiyi_promotion_link_no)
      }, 100)
    },
    iodawqq() {
      this.editInfoVisible = false
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.getList()
    }
  }
}
</script>
